import { LoadableLazy } from '@confluence/loadable';
export const GenericPremiumTipLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GenericPremiumTipLoadable" */ '../src/BiteSizeOnboarding/GenericPremiumTip'
			)
		).GenericPremiumTip,
});
